import { createSlice } from '@reduxjs/toolkit';

//  ------------- Notification payload example -----------

// {
//   notificationState:true,
//   message:"Property was created successfully",
//   error: false,
// }

// notificationQueue is a queue, not a single slot, so that firing two toasts
// back-to-back (e.g. dismiss a "processing" toast, then show the result) can't
// have the first one silently dropped by React 18 batching two dispatches
// made in the same tick into a single render. App.js drains one entry per
// render via notificationConsumed().

const notificationReducer = createSlice({
  name: 'notificationReducer',
  initialState: {
    notificationQueue: []
  },
  reducers: {
    setNotification: (state, action) => {
      // Historically callers "reset" by dispatching setNotification({}) — with
      // a queue there's nothing to clear, so treat an empty payload as a no-op
      // rather than enqueuing a blank toast.
      if(!action.payload || Object.keys(action.payload).length === 0){
        return state;
      }
      return {
        ...state,
        // Guards against state persisted (redux-persist) from before this slice
        // became a queue — that old `{notificationToast: {}}` shape rehydrates
        // with no `notificationQueue` array to spread onto.
        notificationQueue: [...(state.notificationQueue || []), action.payload]
      }
    },
    notificationConsumed: (state) => {
      return {
        ...state,
        notificationQueue: (state.notificationQueue || []).slice(1)
      }
    },
    resetNotification: (state, action) =>{
      return{
        ...state,
        notificationQueue: []
      }
    }
  },
});


export const { setNotification, notificationConsumed, resetNotification } = notificationReducer.actions;
export default notificationReducer.reducer;
